module.exports = __webpack_public_path__ + "static/img/6.a5eb567.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/eng/6.png
// module id = llvB
// module chunks = 0